<template>
  <v-dialog v-model="visible" scrollable persistent max-width="500" @keydown.esc="cancelForm()">
    <v-card>
      <v-card-title class="title">Agregar asignación</v-card-title>
      <v-card-subtitle><small>(*) indica campos requeridos</small></v-card-subtitle>
      <v-divider></v-divider>
      <v-card-text>
        <v-form ref="asignacionForm" v-model="validations.isValid">
          <v-container class="px-0" fluid>
            <v-row v-if="existAsignacion">
              <v-col>
                <v-alert type="error" dense>
                  Ya existe esta asignación para el usuario en cuestión.
                </v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-select
                  v-model="rol"
                  :items="availableRoles.map(rol => rol.name)"
                  :rules="validations.rol"
                  item-text="name"
                  item-value="name"
                  label="Rol*"
                  hide-details="auto"
                  required
                  outlined
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                        <v-list-item-title>{{ availableRoles.filter(rol => rol.name == item)[0].name }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="loading" @click="cancelForm()" class="grey--text" light text>Cancelar</v-btn>
        <v-btn :loading="loading" :disabled="saveIsDisabled" @click="saveForm(true)" color="primary" text>Guardar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    availableRoles: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    visible: true,
    loading: false,
    asignaciones: [],

    // campos del formulario
    rol: null,

    // validaciones
    validations: {
      isValid: true,
      rol: [
        (v) => !!v || 'Debe proporcionar un rol.'
      ]
    }
  }),

  methods: {
    saveForm (close = false) {
      this.$refs.asignacionForm.validate()
      if (this.validations.isValid) {
        this.loading = true

        // Añadir solo el nombre del rol al array de asignaciones
        this.asignaciones.push(this.availableRoles.filter(rol => rol.name === this.rol)[0].value)

        this.$refs.asignacionForm.reset()
        this.$emit('input', this.asignaciones)

        // cerrando el formulario si se dio click en la opción Guardar
        if (close) {
          this.$emit('cancel')
        }

        this.$toast.success('La asignación ha sido registrada satisfactoriamente')
        this.loading = false
      }
    },
    cancelForm () {
      this.$emit('cancel')
    }
  },

  created () {
    this.asignaciones = this.value
  },

  computed: {
    existAsignacion () {
      if (this.rol) {
        return this.asignaciones.includes(this.rol)
      }
      return false
    },
    saveIsDisabled () {
      return this.loading || !this.rol || this.existAsignacion
    }
  }
}
</script>

<style scoped>

</style>
